import { render, staticRenderFns } from "./IndividualSickLeave.vue?vue&type=template&id=1585c160&scoped=true&"
import script from "./IndividualSickLeave.vue?vue&type=script&lang=ts&"
export * from "./IndividualSickLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585c160",
  null
  
)

export default component.exports